// ./src/components/forms/FormCustomerSettings/index.tsx
import React, { useState } from 'react';

import { FaFlag } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';

import {
  SubtitleSecondary,
  Paragraph,
  ButtonOutline,
  ModalUserPassword,
} from '@components/index';
import { apiRebox } from '@services/index';
import { toastify } from '@utils/notifiers';

import {
  Container,
  DividingLine,
  Sections,
  SectionsGroup,
  SectionsItem,
} from './styles';

interface IProps {
  userId: string;
}

const FormCustomerSettings: React.FC<IProps> = ({ userId }) => {
  const [modalPasswordIsOpen, setModalPasswordIsOpen] = useState<boolean>(
    false,
  );

  const [flagPriority, setFlagPriority] = useState<
    'LOWER' | 'NORMAL' | 'HIGHER' | ''
  >('');

  const handlePriority = async (id: string) => {
    try {
      const {
        data: { data: responseUser },
      } = await apiRebox.get(`/users/${id}`);
      const { data } = await apiRebox.put(`/users/${id}`, {
        ...responseUser,
        priority: flagPriority,
      });
      const { header } = data;
      if (header?.status_code) toastify(header.message, 'success');
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const clearPriority = async (id: string) => {
    try {
      const {
        data: { data: responseUser },
      } = await apiRebox.get(`/users/${id}`);
      const { data } = await apiRebox.put(`/users/${id}`, {
        ...responseUser,
        priority: null,
      });
      const { header } = data;
      if (header?.status_code) toastify(header.message, 'success');
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const changeModalPasswordIsOpen = () => {
    setModalPasswordIsOpen(prevState => !prevState);
  };

  return (
    <Container>
      <Sections>
        <SectionsGroup>
          <SectionsItem>
            <SubtitleSecondary
              textAlign="start"
              nameColor="black"
              fontSize={14}
            >
              Atualizar senha
            </SubtitleSecondary>
            <Paragraph
              nameColor="black"
              textAlign="start"
              opacity={0.5}
              fontSize={13}
              style={{ marginBottom: '2vh' }}
            >
              Por questões de segurança, não escolha uma senha muito fácil
            </Paragraph>
          </SectionsItem>
          <SectionsItem>
            <ButtonOutline
              iconLeft={FiLock}
              style={{ maxWidth: 170 }}
              onClick={changeModalPasswordIsOpen}
            >
              Nova senha
            </ButtonOutline>
          </SectionsItem>
        </SectionsGroup>
        <DividingLine />
        <SectionsGroup>
          <SectionsItem>
            <SubtitleSecondary
              textAlign="start"
              nameColor="black"
              fontSize={14}
            >
              Selelecione a bandeira do cliente
            </SubtitleSecondary>
            <Paragraph
              nameColor="black"
              textAlign="start"
              opacity={0.5}
              fontSize={13}
              style={{ marginBottom: '2vh' }}
            >
              Essa bandeira indicará a prioridade do cliente, conforme
              estabelecido com a equipe.
            </Paragraph>
          </SectionsItem>
        </SectionsGroup>
        <SectionsGroup
          style={{
            padding: '0',
            display: 'flex',
            flexDirection: 'row',
            width: '20vw',
          }}
        >
          <SectionsItem style={{ marginLeft: '5px' }}>
            <ButtonOutline
              name="lower"
              onClick={() => {
                setFlagPriority('LOWER');
                toastify('Bandeira selecionada', 'info');
              }}
            >
              <FaFlag size={'18'} style={{ maxWidth: 170, fill: 'blue' }} />
            </ButtonOutline>
          </SectionsItem>
          <SectionsItem style={{ marginLeft: '5px' }}>
            <ButtonOutline
              name="normal"
              onClick={() => {
                setFlagPriority('NORMAL');
                toastify('Bandeira selecionada', 'info');
              }}
            >
              <FaFlag size={'18'} style={{ maxWidth: 170, fill: 'orange' }} />
            </ButtonOutline>
          </SectionsItem>
          <SectionsItem style={{ marginLeft: '5px' }}>
            <ButtonOutline
              name="higher"
              onClick={() => {
                setFlagPriority('HIGHER');
                toastify('Bandeira selecionada', 'info');
              }}
            >
              <FaFlag size={'18'} style={{ maxWidth: 170, fill: 'red' }} />
            </ButtonOutline>
          </SectionsItem>
        </SectionsGroup>
        <SectionsGroup
          style={{
            display: 'flex',
            marginTop: '1rem',
            width: '30vw',
            gap: '1rem',
            alignContent: 'space-evenly',
            alignItems: 'center',
          }}
        >
          <SectionsItem>
            <ButtonOutline onClick={() => handlePriority(userId)}>
              Salvar Bandeira
            </ButtonOutline>
          </SectionsItem>
          <SectionsItem>
            <ButtonOutline onClick={() => clearPriority(userId)}>
              Limpar Bandeira
            </ButtonOutline>
          </SectionsItem>
        </SectionsGroup>
      </Sections>
      <ModalUserPassword
        userId={userId}
        isOpen={modalPasswordIsOpen}
        change={changeModalPasswordIsOpen}
      />
    </Container>
  );
};

export default FormCustomerSettings;
